import * as types from './types';
import { formatSites } from '../../helpers/GenericHelpers';
import { has } from 'lodash';
import { alphaSort } from 'Common/Helpers/SortHelper';

const INITIAL_STATE = {
  loading: false,
  reimbursableItems: [],
  multiplier: null,
  freeMeals: null,
  paidMeals: null,
  sites: [],
  error: null,
  wasWritten: false,
  loadingReimbursableItems: false,
  hasBeenProcessed: false,
  reimbursableItem: null,
  siteStudents: null,
  totalParticipation: null,
  sitesLoading: false,
  isISPNull: false,
  badSites: [],
  currentFiscalYear: null,
  previousFiscalYear: null,
  isBulk: null,
  loadingTotalParticipation: false,
  primarySites: {},
  isDayClosed: false,
  isDayClosedLoading: false,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.CEP_BULK_PROCESSING_GET_REIMBURSABLE_ITEMS:
      if (payload.length === 0) {
        return { ...state, reimbursableItems: [] };
      } else {
        let formattedItems = payload.map(item => {
          return {
            value: item.Item.Id,
            text: item.Item.Description,
          };
        });
        return {
          ...state,
          reimbursableItems: alphaSort(formattedItems),
        };
      }
    case types.CEP_BULK_PROCESSING_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case types.CEP_BULK_PROCESSING_GET_MEAL_VALUES:
      return {
        ...state,
        freeMeals: payload.FreeMeals,
        paidMeals: payload.PaidMeals,
        hasBeenProcessed: payload.HasBeenProcessed,
        reimbursableItem: payload.ReimbursableItem,
        siteStudents: payload.SiteStudents,
        totalParticipation: payload.HasBeenProcessed
          ? payload.FreeMeals + payload.PaidMeals
          : 0,
        isISPNull: payload.IsISPNull,
        isBulk: payload.IsBulk,
      };
    case types.CEP_BULK_PROCESSING_GET_CEP_SITES:
      let badSites = payload.filter(site => site.Percentage === 0);
      let sites = formatSites(payload);

      return {
        ...state,
        sites: sites.sites.length > 0 ? alphaSort(sites.sites) : [],
        sitesLoaded: true,
        badSites: badSites,
        primarySites: sites.primarySites,
      };
    case types.CEP_BULK_PROCESSING_CLEAR_ERROR:
      return { ...state, error: payload };
    case types.CEP_BULK_PROCESSING_WRITE_MEALS:
      return { ...state, wasWritten: payload, hasBeenProcessed: payload };
    case types.CEP_BULK_PROCESSING_CLEAR_WAS_WRITTEN:
      return { ...state, wasWritten: payload };
    case types.CEP_BULK_PROCESSING_LOADING_REIMBURSABLE_ITEMS:
      return { ...state, loadingReimbursableItems: payload };
    case types.CEP_BULK_PROCESSING_LOAD_ERROR:
      let error = null;
      if (has(payload, 'response.data')) {
        if (payload.response.data.Errors) {
          error = payload.response.data.Errors[0].Title;
        } else {
          error = payload.response.data.Message
            ? payload.response.data.Message
            : null;
        }
      }
      return {
        ...state,
        error: error
          ? error
          : 'An error occurred while loading information for this page.',
      };
    case types.CEP_BULK_PROCESSING_SET_ISISPNULL:
      return {
        ...state,
        isISPNull: payload,
      };
    case types.CEP_BULK_PROCESSING_GET_FISCAL_YEARS:
      return {
        ...state,
        previousFiscalYear: payload.data[1],
        currentFiscalYear: payload.data[0],
      };
    case types.CEP_BULK_PROCESSING_SITES_LOADING:
      return {
        ...state,
        sitesLoading: payload,
      };
    case types.CEP_BULK_PROCESSING_LOADING_TOTAL_PARTICIPATION:
      return { ...state, loadingTotalParticipation: payload };
    case types.CEP_BULK_PROCESSING_SET_IS_DAY_CLOSED:
      return { ...state, isDayClosed: payload };
    case types.CEP_BULK_PROCESSING_LOADING_DAY_CLOSED:
      return { ...state, isDayClosedLoading: payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/cepbulkprocessing/state/processing/reducer.js